import { handleActions } from 'redux-actions';
import { holdMusicActions } from '../actions/holdMusicActions';
export function emptyAudio() {
    return {
        name: null,
        chunk_urls: [],
        master_file_path: null,
        chunk_duration_in_secs: 0,
        id: null,
        original_as_mp3_url: null,
    };
}
const initialState = {
    meta: {
        uploadAsyncStatus: 'succeeded',
        getAsyncStatus: 'succeeded',
    },
    ui: {
        isNewAudioOpen: false,
        isHoldingOpen: false,
        isHoldModalOpen: false,
    },
    allAudios: [],
    selectedAudio: emptyAudio(),
    jobIds: [],
};
// Destructure the holdMusic actions.
export const { holdMusicGetAll, holdMusicGetAllSucceeded, holdMusicGetAllFailed, holdMusicUpload, holdMusicUploadSucceeded, holdMusicUploadFailed, holdMusicSplit, holdMusicSplitSucceeded, holdMusicSplitFailed, holdMusicSelect, holdMusicReset, holdMusicShowModal, holdMusicHideModal, holdMusicWsUploadStatus, holdMusicHoldingForSplitingOpen, holdMusicHoldingForSplitingClose, } = holdMusicActions;
const holdMusic = handleActions({
    [holdMusicGetAll.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getAsyncStatus: 'loading' }) });
    },
    [holdMusicGetAllSucceeded.toString()]: (state, action) => {
        const allAudios = [];
        for (const wait_music of action.payload.data.wait_music) {
            allAudios.push({
                id: wait_music.uuid,
                name: wait_music.name,
                chunk_urls: wait_music.chunk_urls,
                master_file_path: wait_music.master_file_path,
                original_as_mp3_url: wait_music.original_as_mp3_url,
                chunk_duration_in_secs: wait_music.chunk_duration_in_secs,
            });
        }
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getAsyncStatus: 'succeeded' }), allAudios: allAudios });
    },
    [holdMusicGetAllFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { getAsyncStatus: 'failed' }) });
    },
    [holdMusicUpload.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { uploadAsyncStatus: 'loading' }) });
    },
    [holdMusicUploadSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { uploadAsyncStatus: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { isNewAudioOpen: true }) });
    },
    [holdMusicUploadFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { uploadAsyncStatus: 'failed' }) });
    },
    [holdMusicSplit.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { uploadAsyncStatus: 'loading' }) });
    },
    [holdMusicSplitSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { uploadAsyncStatus: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { isNewAudioOpen: true }), jobIds: [action.payload.data.job_id, ...state.jobIds] });
    },
    [holdMusicSplitFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { uploadAsyncStatus: 'failed' }) });
    },
    [holdMusicWsUploadStatus.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isHoldingOpen: false, isNewAudioOpen: false }), jobIds: state.jobIds.filter((jobID) => jobID !== action.payload.job_id) });
    },
    [holdMusicSelect.toString()]: (state, action) => {
        const selectedAudio = Object.assign({}, action.payload.selectedAudio);
        return Object.assign(Object.assign({}, state), { selectedAudio: selectedAudio });
    },
    [holdMusicReset.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { selectedAudio: emptyAudio() });
    },
    [holdMusicShowModal.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isHoldModalOpen: true }) });
    },
    [holdMusicHideModal.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isHoldModalOpen: false }) });
    },
    [holdMusicHoldingForSplitingOpen.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isHoldingOpen: true }) });
    },
    [holdMusicHoldingForSplitingClose.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isHoldingOpen: false }) });
    },
}, initialState);
export default holdMusic;
